import "./index.scss";
export function insertSlideCountdownHTML() {
    const html = `
        <section id="countdown" class="has-light-background">
            <div class="countdown__container">
                <div class="countdown__msg text-color text-color--secondary"></div>
                <h3 class="countdown__value text-color"></h3>
            </div>
        </section>
    `;
    document.querySelector("body").innerHTML += html;
}
